/**
 * The visible update prompt (§ 4.7).
 *
 * **A new bundle is never swapped in silently.** `skipWaiting` would replace the
 * code under a half-entered count — the manager's typing is in IndexedDB and would
 * survive, but a reload mid-shelf is still the app taking a decision that belongs
 * to the person holding the iPad. So the new version waits, visibly, until it is
 * accepted.
 *
 * Offline-ready is announced once, quietly, for a different reason: a manager about
 * to walk into a walk-in wants to know the app will keep working, and "it just does"
 * is not something anyone believes about software without being told once.
 */
import { useRegisterSW } from "virtual:pwa-register/react";

export function UpdatePrompt() {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    offlineReady: [offlineReady, setOfflineReady],
    updateServiceWorker,
  } = useRegisterSW();

  if (needRefresh) {
    return (
      <div className="update-prompt" role="status" data-testid="update-prompt">
        <span>
          <strong>A new version of this app is ready.</strong> Your counts are saved —
          nothing is lost by reloading.
        </span>
        <span className="update-prompt__actions">
          <button type="button" onClick={() => void updateServiceWorker(true)}>
            Reload now
          </button>
          <button type="button" className="ghost" onClick={() => setNeedRefresh(false)}>
            Later
          </button>
        </span>
      </div>
    );
  }

  if (offlineReady) {
    return (
      <div className="update-prompt update-prompt--calm" role="status" data-testid="offline-ready">
        <span>Ready to count without a signal.</span>
        <button type="button" className="ghost" onClick={() => setOfflineReady(false)}>
          Dismiss
        </button>
      </div>
    );
  }

  return null;
}
